var map = {
	"./lever00.png": "c4ed",
	"./lever01.png": "cc7d",
	"./lever02.png": "0c99",
	"./lever03.png": "c9ed",
	"./lever04.png": "80f7",
	"./lever05.png": "631f",
	"./lever06.png": "0446",
	"./lever07.png": "eb5b",
	"./lever08.png": "61d8",
	"./lever09.png": "113d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bcf";